(function ($) {

    'use strict';

    const WebChat = function () {

            const parent = document.getElementById('tdWebchat');

            const init = function () {
                if (parent) {
                    waitForShadowRoot().then(
                        () => {
                            setupStyles();
                        }
                    )
                }
            };

            const waitForShadowRoot = function() {
                return new Promise(resolve => {
                        if (parent.shadowRoot) {
                                return resolve();
                        }

                        const observer = new MutationObserver(mutations => {
                                if (parent.shadowRoot) {
                                        resolve();
                                        observer.disconnect();
                                }
                        });

                        observer.observe(document, {
                                childList: true,
                                subtree: true
                        });
                });
        }

            const setupStyles = function() {
                const webChat = parent.shadowRoot;
                const styles = document.createElement("style");
                const css = "\
                .digital-webchat-wrapper [data-qa=trigger-button] { \
                    width: 135px;\
                    height: auto;\
                    background: none !important;\
                    border-radius: 0;\
                    right: 8px; \
                    bottom: 8px; \
                }\
                .digital-webchat-wrapper [data-qa=trigger-button] img{ \
                    aspect-ratio: 2.90;\
                    width: 13.5rem !important;\
                    height: auto !important;\
                }\
                ";

                styles.appendChild(document.createTextNode(css));

                webChat.appendChild(styles);

                // Ensure pop-up sits above main nav
                parent.style.position = 'relative';
                parent.style.zIndex = 1000000;

                // Push up accessibility plugin
                const reciteMe = document.querySelector('.recite-me');
                const reciteMeButton = document.querySelector('.recite-me__btn');

                if (reciteMe) {
                    reciteMe.style.bottom = '70px';
                }

                if (reciteMeButton) {
                    reciteMeButton.style.borderRadius = '5px';
                }
            }


            return {
                    init: init
            };

    }();

    module.exports = WebChat;

})(jQuery);
